import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type User = {
  seller: '1P' | '3P';
  hasBrand?: boolean;
  setSeller: (seller: '1P' | '3P') => void;
  setHasBrand: (hasBrand: boolean) => void;
};
export const userStore = create<User>()(
  devtools((set) => ({
    seller: '1P',
    hasBrand: false,
    setSeller: (seller) => set(() => ({ seller: seller })),
    setHasBrand: (hasBrand) => set(() => ({ hasBrand: hasBrand })),
  })),
);
